export const openIdProviderConfigPath = 'oidc/.well-known/openid-configuration';
